<svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
  <path
    opacity="0.2"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33ZM18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M31.8582 23.7403C32.612 21.9204 33 19.9698 33 18H36C36 20.3638 35.5344 22.7044 34.6298 24.8883C33.7252 27.0722 32.3994 29.0565 30.7279 30.7279C29.0565 32.3994 27.0722 33.7252 24.8883 34.6298C22.7044 35.5344 20.3638 36 18 36L18 33C19.9698 33 21.9204 32.612 23.7403 31.8582C25.5601 31.1044 27.2137 29.9995 28.6066 28.6066C29.9995 27.2137 31.1044 25.5601 31.8582 23.7403Z"
  />
</svg>
